import { TenantInfo, CreateTenantForm } from '@/features/auth';
import { axios } from '@/lib/axios';

export const APIupdateTenant = (tenantId: string, data: CreateTenantForm): Promise<TenantInfo> => {
    return axios.put(`/tenant/${tenantId}`, { data });
};
